import React, {Component} from 'react';
import {View, Text} from 'react-native';
import styled from 'styled-components/native';
import {colours, fontSize, spacing} from '../../styles/Style';
import {GetGlobalTheme} from '../../Tools/DisplayTools';
import {CheckBox} from 'react-native-elements';
import {IsApproved} from '../../utils/helpers';
import * as myDate from '../../Tools/DateTools';
import {MatrixContainer} from '../edit_elements/Matrix';
import {DefaultIconButton} from '../button/DefaultIconButton';
import EditField from './EditField';
import {translate} from '../../Tools/LanguageTools';
import {ActionButton} from '../button/ActionButton';

const ShiftSwitchContainer = styled.View`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 2px;
  padding-bottom: 20px;
  border-radius: 3px;
  background-color: ${colours[GetGlobalTheme()].mainBackground};
  margin-left: 20px;
`;
const ShiftWrapper = styled.View`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 2px;
  border-radius: 3px;
  background-color: ${colours[GetGlobalTheme()].mainBackground};
`;
const ShiftButton = styled.TouchableOpacity`
  margin-right: 5px;
`;
const ChekboxWrapper = styled.TouchableOpacity`
  padding-left: 2px;
`;

const EditWrap = styled.View`
  padding-left: 2px;
`;

const ShiftButtonText = styled.Text`
  color: ${colours[GetGlobalTheme()].titleText};
  border: 1px solid ${colours[GetGlobalTheme()].normalHighligh};
  padding: 4px 10px;
  border-radius: 3px;
  font-size: ${fontSize.small200};
`;

const NormalText = styled.Text`
  background-color: transparent;
  width: 100%;
  text-align: center;
  border-bottom: none;
  color: ${colours[GetGlobalTheme()].rowText};
`;

function GetWebColor(setcolor, transp = '0.4') {
  let res = '';
  switch (setcolor) {
    case '1':
      res = 'rgba(0, 146, 211, ' + transp + ')';
      break;
    case '2':
      res = 'rgba(0, 75, 119, ' + transp + ')';
      break;
    case '3':
      res = 'rgba(0, 30, 69, ' + transp + ')';
      break;
    case '4':
      res = 'rgba(208, 139, 196, ' + transp + ')';
      break;
    case '5':
      res = 'rgba(170, 42, 127, ' + transp + ')';
      break;
    case '6':
      res = 'rgba(140, 96, 181, ' + transp + ')';
      break;
    case '7':
      res = 'rgba(104, 82, 136, ' + transp + ')';
      break;
    case '8':
      res = 'rgba(125, 215, 123, ' + transp + ')';
      break;
    case '9':
      res = 'rgba(136, 172, 143, ' + transp + ')';
      break;
    case '10':
      res = 'rgba(0, 126, 148, ' + transp + ')';
      break;
    case '11':
      res = 'rgba(255, 152, 84, ' + transp + ')';
      break;
    case '12':
      res = 'rgba(249, 106, 96, ' + transp + ')';
      break;
    case '13':
      res = 'rgba(218, 66, 114, ' + transp + ')';
      break;
    //default:
    //  res = 'rgba(218, 66, 114, 0.4)';
  }

  return res;
}

function GetDayColor(record) {
  let vColor = {};
  let td = myDate.ExtractDateFromString(record.StartDate);
  if (td) {
    for (let i = 1; i < 32; i++) {
      let day = td.getDay();
      if (global.transferredDays[td]) {
      } else {
        let tt = myDate.ConstructDateString2(td);
        if (global.transferredDays2[tt]) {
          vColor[i] = GetWebColor(global.shiftBlock.ColorWeekend);
        }
        if (day == 6 || day == 0) {
          vColor[i] = GetWebColor(global.shiftBlock.ColorWeekend);
        }
        if (global.holidaysvector[tt]) {
          vColor[i] = GetWebColor(global.shiftBlock.ColorHoliday);
        }
      }
      td.setDate(td.getDate() + 1);
    }
  }
  return vColor;
}

function ShiftInDay(str, interval) {
  let res = 0;
  let list = str.split2(',');
  if (interval != '') {
    if (list.indexOf(interval) > -1) {
      res = 1;
    } else {
      if (list != '') {
        res = 2;
      }
    }
  }
  return res;
}

const ShiftSwitch = (props) => {
  let group = [];
  if (
    global.pasteSpecialsVector['13_2'].hasOwnProperty(
      props.window.props.record.ShiftGroup
    )
  ) {
    group =
      global.pasteSpecialsVector['13_2'][props.window.props.record.ShiftGroup];
  }
  return (
    <ShiftSwitchContainer>
      {group.map((interval, index) => {
        let intrec = global.pasteSpecialsVector[14][interval.ShiftInterval];
        let comment =
          interval.IntervalComment + ' (' + interval.ShiftInterval + ')';
        if (intrec) {
          comment +=
            '\n' +
            intrec.FromTime.substring(0, 5) +
            '-' +
            intrec.ToTime.substring(0, 5);
        } else {
          comment += '\n' + translate('IntervalNotFound');
        }
        let style = {};
        if (interval.ShiftInterval == props.window.state.activeInterval) {
          style.backgroundColor = colours[GetGlobalTheme()].buttonBackgroundAlt;
        }
        return (
          <ShiftButton
            onPress={() => {
              props.window.switchShifts(interval.ShiftInterval);
            }}
          >
            <ShiftButtonText style={style}>{comment}</ShiftButtonText>
          </ShiftButton>
        );
      })}
    </ShiftSwitchContainer>
  );
};

class ShiftContainer extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.switchShifts = this.switchShifts.bind(this);
    this.localrows = [];
    this.localrecord = {rows: []};
    this.localcolumns = JSON.parse(JSON.stringify(props.columns));
    this._skipUpdate = false;
    let tmp = global.pasteSpecialsVector['13_2'][this.props.record.ShiftGroup];
    let interval = '';
    if (tmp && tmp.length > 0) {
      interval = tmp[0].ShiftInterval;
    }
    this.state = {
      update: false,
      activeInterval: interval,
      px: {},
      py: {},
      StartTime: '00:00:00',
      EndTime: '00:00:00',
      EditSlot: '',
    };

    this.setLocalRecord(this.state.activeInterval);
    for (let i = 0; i < this.localcolumns.length; i++) {
      if (this.localcolumns[i].dataKey.substring(0, 3) == 'Day') {
        this.localcolumns[i].overwrite = this.showShiftCell;
      }
      if (this.localcolumns[i].dataKey == 'LineFlag') {
        this.localcolumns[i].overwrite = this.showShiftCell;
      }
      if (this.localcolumns[i].dataKey == 'TotalHoursRow') {
        this.localcolumns[i].overwrite = this.showRowTotal;
      }
    }
  }
  componentWillUpdate(props) {
    if (this._skipUpdate == false) {
      const descriptor = Object.getOwnPropertyDescriptor(this.props, 'record');
      if (descriptor.writable) {
        this.props.record = props.record;
      }
      this.setLocalRecord(this.state.activeInterval);
    } else {
      this._skipUpdate = false;
    }
  }
  switchShifts = (shift) => {
    this.setLocalRecord(shift);
    this._skipUpdate = true;
    this.setState({activeInterval: shift});
  };

  ColumnIsEditable = (columnindex) => {
    let res = false;
    if (
      this.props.columns[columnindex].viewOnly == false &&
      IsApproved(this.props.record, this.props.okcheck) == false
    ) {
      res = true;
    }
    if (
      this.props.columns[columnindex].dataKey == 'LineFlag' &&
      IsApproved(this.props.record, this.props.okcheck) == false
    ) {
      res = true;
    }
    return res;
  };

  IntervalExists = (colval) => {
    let res = false;
    if (global.pasteSpecialsVector[14].hasOwnProperty(colval)) {
      res = true;
    }

    return res;
  };
  GetOffWorkColor = (colval) => {
    let res = '';
    if (global.pasteSpecialsVector[19].hasOwnProperty(colval)) {
      res = GetWebColor(global.pasteSpecialsVector[19][colval].shiftcolor);
    }

    return res;
  };

  GetIntervalColor = (colval) => {
    let res = '';
    if (global.pasteSpecialsVector[14].hasOwnProperty(colval)) {
      res = GetWebColor(global.pasteSpecialsVector[14][colval].color);
    }

    return res;
  };

  ShowInactiveShiftDay2 = (rowindex, colkey) => {
    let res = false;
    let colval = this.props.record.rows[rowindex][colkey];
    let colcolor = '';
    if (colval != '') {
      if (
        colval.indexOf(',') == -1 &&
        this.IntervalExists(colval) == false &&
        colval.indexOf(':') == -1
      ) {
        res = true;
        colcolor = this.GetOffWorkColor(colval);
      } else {
        if (this.IntervalExists(colval)) {
          colcolor = this.GetIntervalColor(colval);
        }
      }
    }
    if (colkey == 'LineFlag') {
      res = false;
    }
    return {res: res, colkey: colkey, colval: colval, colcolor: colcolor};
  };

  ShowInactiveShiftDay = (rowindex, columnindex) => {
    let colkey = this.props.columns[columnindex].dataKey;
    return this.ShowInactiveShiftDay2(rowindex, colkey);
  };

  DayIsRedDay = (colkey) => {
    let res = false;
    let day = parseInt(colkey.replace('Day', ''));
    let td = myDate.ExtractDateFromString(this.props.record.StartDate);
    if (td) {
      td.setDate(day);
      let tday = td.getDay();
      let tt = myDate.ConstructDateString2(td);
      if (global.transferredDays[tt]) {
      } else {
        if (global.transferredDays2[tt]) {
          res = true;
        }
        if (tday == 6 || tday == 0) {
          res = true;
        }
        if (global.holidaysvector[tt]) {
          res = true;
        }
      }
    }
    return res;
  };

  showShiftCell = (value, rowindex, columnindex) => {
    let self = this;
    let updatef = true;
    let opacity = '0.7';
    let color = colours[GetGlobalTheme()].titleText;
    let editablef = true;
    let res = this.ShowInactiveShiftDay(rowindex, columnindex);
    if (res.res) {
      color = colours[GetGlobalTheme()].inactiveTitleText;
      editablef = false;
    }
    if (value == 2) {
      value = 0;
      updatef = false;
      opacity = '0.3';
      editablef = false;
    }
    /*
    let updatef = true;
    if (this.DayIsOffWork(res.colkey)) {
      updatef = false;
    }
    */
    let style = {};
    if (res.colcolor != '') {
      style = {
        backgroundColor: res.colcolor,
        height: '32px',
        lineHeight: '32px',
      };
    }
    /*
    if (
      this.state.activeInterval == '!!MANUAL!!' &&
      this.props.columns[columnindex].dataKey != 'LineFlag'
    ) {
      let key = rowindex + ':' + columnindex;
      return (
        <>
          <EditWrap
            style={style}
            onLayout={(event) => {
              const layout = event.nativeEvent.layout;
              self.state.py[key] = layout.top;
              self.state.px[key] = layout.left;
            }}>
            <DefaultIconButton
              style={{height: 'auto', width: 'auto', padding: 0, margin: 0}}
              iconName={'edit'}
              mode="text"
              size={12}
              iconType="FA5"
              action={() => {
              }}
            />
          </EditWrap>
        </>
      );
    } else {
*/
    if (editablef) {
      return (
        <ChekboxWrapper style={style}>
          <CheckBox
            onPress={(e) => {
              if (updatef && self.ColumnIsEditable(columnindex)) {
                self.updateShiftCellValue(
                  rowindex,
                  columnindex,
                  value == '0' || value == ''
                );
              }
            }}
            size={18}
            checked={value == 1 ? true : false}
            checkedIcon="check-square"
            uncheckedIcon="square"
            iconType="font-awesome-5"
            checkedColor={colours[GetGlobalTheme()].titleText}
            uncheckedColor={colours[GetGlobalTheme()].titleText}
            containerStyle={{
              margin: '0px !important',
              marginLeft: '0px !important',
              marginRight: '0px !important',
              padding: '0px !important',
              transform: 'scale(0.8)',
              opacity: opacity,
            }}
          />
        </ChekboxWrapper>
      );
    } else {
      let val = res.colval;
      if (val.indexOf(':') > -1) {
        val = '!M';
      }
      return (
        <View style={style}>
          <NormalText>{val}</NormalText>
        </View>
      );
    }
    //    }
  };

  showRowTotal = (value, rowindex, columnindex) => {
    let self = this;
    let style = {};
    if (parseFloat(value) > parseFloat(this.props.record.NormalHours)) {
      style = {
        backgroundColor: GetWebColor(global.shiftBlock.colornormhours),
        height: '32px',
        lineHeight: '32px',
      };
    }
    return (
      <View style={style}>
        <NormalText>{value}</NormalText>
      </View>
    );
  };

  updateShiftCellValue = (rowid, columnindex, addf) => {
    let id = this.props.columns[columnindex].dataKey;
    let arr = [];
    if (this.props.record.rows[rowid][id] != '') {
      arr = this.props.record.rows[rowid][id].split2(',');
    }
    let interval = this.state.activeInterval;
    let newval = this.props.record.rows[rowid][id];
    if (addf) {
      if (arr.indexOf(interval) == -1) {
        arr.push(interval);
        newval = arr.join(',');
      }
    } else {
      let pos = arr.indexOf(interval);
      if (pos > -1) {
        arr.splice(pos, 1);
        newval = arr.join(',');
      }
    }
    this.props.record.rows[rowid][id] = newval;
    if (id == 'LineFlag') {
      newval = (addf ? '1' : '') + ':' + interval;
    }
    this.props.columns[columnindex].onchange(rowid, id, newval);
    //this.setLocalRecord(this.state.activeInterval);
    //this.setState({update: this.state.update ? false : true});
  };

  IsNextWorkDayOff = (inactf, day, index) => {
    let res = false;

    if (inactf == false) {
      for (let i = day + 1; i < 32; i++) {
        let reddayf = this.DayIsRedDay('Day' + i);
        let dayres = this.ShowInactiveShiftDay2(index, 'Day' + i);
        if (!reddayf) {
          if (dayres.res) {
            res = true;
          }
          i = 32;
        }
      }
    }
    return res;
  };

  setLocalRecord = (shift) => {
    this.localrows = [];
    this.props.record.rows.map((row, index) => {
      let lastreddayf = false;
      let lastworkdayoff = false;
      let lastworkdaynum = 1;
      let hadworkdayf = false;
      let nrow = Object.assign({}, row);
      for (let i = 1; i < 32; i++) {
        let res = this.ShowInactiveShiftDay2(index, 'Day' + i);
        let reddayf = this.DayIsRedDay('Day' + i);
        if (res.res) {
          lastworkdayoff = true;
          lastworkdaynum = i;
        } else {
          if (!reddayf) {
            lastworkdayoff = false;
            lastworkdaynum = 0;
          }
        }
        if (res.res) {
          // || (reddayf && this.IsNextWorkDayOff(res.res, i, index))
          nrow['Day' + i] = 2;
        } else {
          nrow['Day' + i] = ShiftInDay(row['Day' + i], shift);
        }
      }
      let testf = true;
      for (let j = 1; j < 32; j++) {
        let reddayf = this.DayIsRedDay('Day' + j);
        if (reddayf == false && nrow['Day' + j] == 0) {
          testf = false;
        }
      }
      if (testf) {
        nrow['LineFlag'] = 1;
      }

      this.localrows.push(nrow);
    });
  };

  render() {
    return (
      <ShiftWrapper
        width={this.props.width}
        key={JSON.stringify(this.localrows)}
      >
        <ShiftSwitch window={this} />
        <MatrixContainer
          data={this.localrows}
          columns={this.localcolumns}
          record={this.localrecord}
          okcheck={this.props.okcheck}
          title={this.props.title}
          rowactions={this.props.rowactions}
          width={this.props.width}
          splitrow={this.props.splitrow}
          splitrowend={this.props.splitrowend}
          pagination={this.props.pagination}
        />
      </ShiftWrapper>
    );
  }
}

export default ShiftContainer;
export {GetDayColor, GetWebColor};
